module.exports = __webpack_public_path__ + "static/media/icon-user-friends.af308335.svg";